import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen
const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 1000
};

// Summary And Greeting Section
const illustration = {
  animated: false
};

const greeting = {
  name: "Alex Woodall",
  title: "",
  subTitle: emoji(`
    I am an experienced Software Developer
    actively looking to leverage my technical
    knowledge and leadership experience in a
    Software Development role. In my most recent position as a Full Stack Software Engineer at Main Street Health, one of the fastest-growing healthcare startups in the United States, I played a pivotal role in designing, building, and scaling the company’s primary application in every phase of the Software Development Life Cycle. Collaborating with both technical and non-technical stakeholders, I contributed to the development and implementation of new application features, optimizing database structure and code to enhance overall performance. My ability to mentor junior team members and foster a collaborative work environment stems from my background as a Psychological Operations Specialist Team Leader in the US Army, where I developed and led various training for 16 African nations, facilitated cross-training initiatives for a wide variety of class sizes, and promoted leadership development among team members.
    `),
  resumeLink:
    "https://drive.google.com/file/d/1ySjmpC-2ya4Fz9y9Pr-Rhq30PwAlZU6E/view?usp=sharing",
  displayGreeting: true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/aww2539",
  linkedin: "https://www.linkedin.com/in/alexander-w-woodall/",
  gmail: "alexander.w.woodall@gmail.com",
  // gitlab: "",
  // facebook: "",
  // instagram: "",
  // twitter: "",
  // medium: "",
  // stackoverflow: "",
  display: true
};

// Skills Section

const skillsSection = {
  title: "Technologies",
  subTitle: "",
  skills: [
    emoji(
      "⚡ Front End: HTML, CSS, JavaScript, TypeScript, React, Material UI, Bootstrap"
    ),
    emoji("⚡ Back End: Python, Django, Elixir, Phoenix, Ecto, NodeJS"),
    emoji("⚡ Database: SQL, MySQL, PostgreSQL, MongoDB")
  ],

  /* Font Awesome Classnames URL: https://fontawesome.com/icons?d=gallery */
  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "react",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "python/django",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "elixir/erlang",
      fontAwesomeClassname: "fab fa-erlang"
    },
    {
      skillName: "sql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    }
  ],
  display: true
};

// Work experience section 1
// With Resume Bullets
// const workExperiences = {
//   display: true,
//   experience: [
//     {
//       role: "Full Stack Software Engineer",
//       company: "Main Street Health",
//       companylogo: require("./assets/images/mshLogo.png"),
//       date: "January 2022 – February 2024",
//       desc: "I joined this rural healthcare startup when it was less than a year old and played a significant role in all phases of the Software Development Life Cycle.",
//       descBullets: [
//         "Collaborated with technical and non-technical stakeholders to design, build, and implement new application features for a healthcare management system serving ~1,000,000 patients.",
//         "Maintained and optimized existing database structure, back-end code, and frontend code to improve overall performance contributing to the company’s rapid expansion into 25 new states.",
//         "Owned multiple projects focused on database and API optimization that were instrumental to a ~25% increase in page load speeds application-wide.",
//         "Built reusable application components resulting in faster scalability.",
//         "Provided daily support resolving customer issue tickets."
//       ]
//     },
//     {
//       role: "Software Developer",
//       company: "Nashville Software School",
//       companylogo: require("./assets/images/nssLogo.png"),
//       date: "June 2021 – January 2022",
//       desc: "NSS is an intensive, full-time software development bootcamp focusing on HTML, CSS, JavaScript, React and server-side fundamentals with Python and Django.",
//       descBullets: [
//         "Developed 10+ applications with React and with a focus on a modern ES6+ Javascript feature and modular code.",
//         "Contributed to database planning by building entity relationship diagrams (ERD) to define relationships with an emphasis on maintaining a flat data structure.",
//         "Utilized vanilla JavaScript (ES6), and React.js to create single page dynamic web applications using full CRUD functionality.",
//         "Completed 6 group project sprints with code reviews and collaborative application design planning.",
//         "Managed projects with issue tickets and GitHub Projects."
//       ]
//     },
//     {
//       role: "Psychological Operations Specialist Team Leader",
//       company: "United States Army",
//       companylogo: require("./assets/images/armyLogo.png"),
//       date: "July 2011 – July 2023",
//       desc: "",
//       descBullets: [
//         "Mentored junior team members on leadership and functional skills resulting in promotions to lead their own teams.",
//         "1+ years spent abroad in Europe and Africa cross-training with partner nations and supporting combat operations.",
//         "Successfully trained 16 different African nations’ militaries in counterterrorism operations.",
//         "Facilitated a wide variety of trainings with attendance up to 100 individuals.",
//       ]
//     }
//   ]
// };

// Work experience section 2
// Without Resume Bullets
const workExperiences = {
  display: true,
  experience: [
    {
      role: "Full Stack Software Engineer",
      company: "Main Street Health",
      companylogo: require("./assets/images/mshLogo.png"),
      date: "January 2022 – February 2024",
      desc: "I joined this rural healthcare startup when it was less than a year old and played a significant role in all phases of the Software Development Life Cycle.",
      descBullets: null
    },
    {
      role: "Software Developer",
      company: "Nashville Software School",
      companylogo: require("./assets/images/nssLogo.png"),
      date: "June 2021 – January 2022",
      desc: "NSS is an intensive, full-time software development bootcamp focusing on HTML, CSS, JavaScript, React and server-side fundamentals with Python and Django.",
      descBullets: null
    },
    {
      role: "Psychological Operations Specialist Team Leader",
      company: "United States Army",
      companylogo: require("./assets/images/armyLogo.png"),
      date: "July 2011 – July 2023",
      desc: "",
      descBullets: [
        "Mentored junior team members on leadership and functional skills resulting in promotions to lead their own teams.",
        "1+ years spent abroad in Europe and Africa developing and leading training for 20+ partner nations in support of combat operations."
      ]
    }
  ]
};

// Education Section
const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Nashville Software School",
      logo: null,
      subHeader: "Software Development Certification",
      duration: "June 2021 - January 2022",
      desc: null,
      descBullets: null
    },
    {
      schoolName: "Ivy Tech Community College",
      logo: null,
      subHeader: "AAS in Criminal Justice",
      duration: "January 2013 - May 2017",
      desc: null,
      descBullets: null
    }
  ]
};

// Top 3 Skills
const techStack = {
  viewSkillBars: false,
  experience: [
    {
      Stack: "Frontend/Design",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true",
  display: false
};

const bigProjects = {
  title: "Big Projects",
  subtitle: "Start-up companies or other big projects to showcase",
  projects: [
    {
      image: null,
      projectName: "",
      projectDesc: "",
      footerLink: [
        {
          name: "",
          url: ""
        }
      ]
    }
  ],
  display: false
};

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Achievements, Certifications, and Awards",

  achievementsCards: [
    {
      title: "",
      subtitle: "",
      image: null,
      imageAlt: "",
      footerLink: [
        {
          name: "",
          url: ""
        }
      ]
    }
  ],
  display: false
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Feel free to call/text/email me. I'm actively searching for my next role!",
  number: "765-918-1106",
  email_address: "alexander.w.woodall@gmail.com"
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  contactInfo,
  isHireable
};
